import Http from '../http';

const prefix = '/website';

var softCache = [];

const encodeDataToURL = data => {
  return Object.keys(data)
    .map(value => `${value}=${encodeURIComponent(data[value])}`)
    .join('&');
};

export const getDataGraphs = website_id => {
  return Http.authApi().get(`${prefix}/data/graphs/${website_id}`);
};

export const getDataAccess = website_id => {
  return Http.authApi().get(`${prefix}/data/access/${website_id}`);
};

export const getWebsites = (page_published = 1, page_unpublished = 1, filters = 0) => {
  return Http.authApi().get(
    `/my-websites-user?page_published=${page_published}&page_unpublished=${page_unpublished}&new_layout=1&${encodeDataToURL(filters)}&time=` + Date.now()
  );
};

export const getAllWebsites = (page_all = 1,  filters = 0) => {
  return Http.authApi().get(`/get-websites-all?page_all=${page_all}&${encodeDataToURL(filters)}`);
};

export const getDashboardData = (period) => {
  return Http.authApi().get(`user/dashboard/numbers/${period}`);
};

export const getWebsitesAll = () => {
  return Http.authApi().get('/websites-all');
};

export const getAllUserWebsites = () => {
  return Http.authApi().get(
    `${prefix}s`
  );
};

export const get = website => {
  if (typeof website === 'object') {
    return Http.authApi().get(`${prefix}/${website.encrypted_id}`);
  }
  if (typeof website === 'string') {
    return Http.authApi().get(`${prefix}/${website}`);
  }
};

export const getSplitTest = website => {
  if (typeof website === 'object') {
    return Http.authApi().get(`${prefix}/data/split-tests/${website.encrypted_id}`);
  }
  if (typeof website === 'string') {
    return Http.authApi().get(`${prefix}/data/split-tests/${website}`);
  }
};

export const create = website => Http.authApi().post(`${prefix}`, website);

export const edit = website =>
  Http.authApi().put(`${prefix}/${website.encrypted_id}`, website);

export const editScripts = website =>
  Http.authApi().put(`${prefix}/config-scripts/${website.encrypted_id}`, website);

export const editSeo = website =>
  Http.authApi().put(`${prefix}/config-seo/${website.encrypted_id}`, website);

export const exclude = website =>
  Http.authApi().delete(`${prefix}/${website.encrypted_id}`, website);

export const deletedWebsitesSelected = data =>
  Http.authApi().post(`${prefix}/delete-selected-websites`, data);

export const editCategories = website =>
  Http.authApi().put(`${prefix}/categories/${website.encrypted_id}`, website);

// Services
export const updateStatus = data =>
  Http.authApi().put(`${prefix}/${data.encrypted_id}/status`, data);

export const duplicateWebsite = website =>
  Http.authApi().post(`duplicate${prefix}/${website.encrypted_id}`, website);

export const transferWebsite = (website, email) =>
  Http.authApi().post(`${prefix}/transfer/${website.encrypted_id}`, email);

export const transferDuplicateWebsite = (website, email) =>
  Http.authApi().post(
    `${prefix}/transfer/${website.encrypted_id}/duplicate`,
    email
  );

export const transferDuplicateTemplate = (website, email) =>
  Http.authApi().post(
    `${prefix}/transfer/${website.encrypted_id}/template`,
    email
  );



// WEBPACK FOOTER //
// ./src/js/services/editor/website.js